import { render, staticRenderFns } from "./GroupRoomsPanel.vue?vue&type=template&id=9585718e&scoped=true"
import script from "./GroupRoomsPanel.vue?vue&type=script&lang=js"
export * from "./GroupRoomsPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupRoomsPanel.vue?vue&type=style&index=0&id=9585718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585718e",
  null
  
)

export default component.exports